// extracted by mini-css-extract-plugin
export var cardIcon = "_6z-5";
export var cardIconUnframed = "_6z-9";
export var checkboxCard = "_6z-0";
export var checkboxCardSelected = "_6z-4";
export var disabled = "_6z-2";
export var interactive = "_6z-1";
export var outerBorder = "_6z-3";
export var spacerMedium = "_6z-8";
export var spacerSmall = "_6z-7";
export var spacerXsmall = "_6z-6";